//noinspection JSFileReferences
import jump from 'jump.js'

// Höhe der fixierten Navigationsleiste (3rem = ~48px) + etwas Luft
const NAV_OFFSET = -84

//noinspection JSUnusedGlobalSymbols
export default {

    install(Vue) {

        const scrollTo = (selector, offset = NAV_OFFSET) => {
            return () => jump(selector, { duration: 350, offset })
        }

        const focus = selector => {
            return () => $(selector).first().find('input:first').focus()
        }

        Vue.prototype.$scrollTo = selector => {
            Vue.nextTick(scrollTo(selector))
        }

        Vue.prototype.$scrollToAndFocus = selector => {
            return Promise.all([
                Vue.nextTick().then(scrollTo(selector)),
                Vue.nextTick().then(focus(selector))
            ])
        }

        Vue.prototype.$scrollToErrorAndFocus = () => {
            return Promise.all([
                Vue.nextTick().then(scrollTo('.field.error')),
                Vue.nextTick().then(focus('.field.error'))
            ])
        }

    }

}
